
<template>
    <div class="signUp">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h2>
                       Corporate Gift Purchase
                    </h2>
                    <alert v-model="error.show" placement="top-right" duration="2000" type="danger" width="400px" dismissable>
                        <span class="icon-info-circled alert-icon-float-left"></span>
                        <strong>Error:</strong>
                        <p id="signup_errormsg">{{error.message}}</p>
                    </alert>
                    <div class="row margin-top">
                        <div class="col-md-8">
                            <div class="left-content">
                                <div class="panel panel-default text-left">

                                    <div class="row">
                                        <div class="col-sm-4">
                                            <div>
                                                <h4>
                                                    <span>1.</span> Gift Selection
                                                </h4>
                                            </div>
                                            <div class="panel-body">
                                                <br />
                                                <div class="gifts row" v-if="giftPlans">
                                                    <div class="col-sm-6"  v-for="plan in this.giftPlans">
                                                        <div class="gift-item">
                                                            <h5>
                                                                <input type="radio" name = "pkg" :value="plan.packageId" v-model="packageId" :checked="plan.packageId == packageId" /><br /><strong>Gift of TONE</strong>
                                                                <br /><small>{{plan.description}}</small>
                                                            </h5>
                                                            <button v-if="packageId !== plan.packageId" @click="packageId=plan.packageId">${{plan.amount}}</button>
                                                            <button v-if="packageId === plan.packageId" class="active" @click="packageId=plan.packageId">${{plan.amount}}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <br />
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <h4 class="margin-bot-20"><span>2.</span> Select Corporate Client</h4>
                                            <div class="clearfix gap"></div>
                                            <select class="form-control" v-model="clientId" v-if="getCorporateClients">
                                                <option v-for="option in getCorporateClients" :value="option.corporationId">
                                                    {{ option.name }}
                                                </option>
                                            </select>

                                        </div>
                                        <div class="col-sm-4">
                                            <h4 class="margin-bot-20"><span>3.</span> Select CSV File</h4>
                                            <div class="clearfix gap"></div>
                                        <input class="btn btn-primary" type="file" @change="onFileChange" id="corporateUpload">

                                        <button class="btn formButton btn-block" type="submit" id="signup_button"  :disabled = "this.spinner" @click="onPaymentSubmit">
                                            Send Gift
                                            <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                                        </button>
                                    </div>
                                        <div class="col-sm-12">
                                            <h4 v-if="gifteeCol.length > 0">Recipients <button class="btn btn-primary" @click="gifteeCol=[]">Delete All ({{gifteeCol.length}})</button></h4>

                                            <br />
                                            <div class="table-responsive">
                                            <table v-if="gifteeCol.length > 0">
                                                <thead>
                                                <tr>
                                                    <th>Recipient</th>
                                                    <th>Package</th>
                                                    <th>Message</th>
                                                    <th>Delivery Date</th>
                                                    <th>&nbsp;</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="entry in gifteeCol">
                                                    <td>{{entry.gifteeFirstName}}&nbsp;{{entry.gifteeLastName}}<br>
                                                        {{entry.gifteeEmail}}
                                                    </td>
                                                    <td>{{getPackageInfo(entry.packageId)[0].description}}&nbsp;${{getPackageInfo(entry.packageId)[0].amount}}</td>
                                                    <td>{{entry.deliveryMessage}}</td>
                                                    <td>{{returnFormatedDate(entry.deliveryDate, 'A')}}</td>
                                                    <td><button class="btn formButton" @click="removeGiftee(entry)"><i class="fa fa-times"></i></button></td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            </div>
                                            <div class="right-content" v-if="gifteeCol.length > 0">
                                                <div class="jumbotron text-center">
                                                    <p>Total Recipients : <b>{{gifteeCol.length}}</b> </p>
                                                    <!--<p>Total Amount: <b>${{this.totalAmount}}</b></p>-->
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>
                        <!--<div class="col-md-4">-->
                            <!--<div class="left-content">-->
                                <!--<accordion :one-at-atime="true">-->
                                    <!--<panel :is-open="true"  class="text-left">-->
                                        <!--<h4><span>3.</span> Your Information</h4>-->
                                        <!--&lt;!&ndash;<h4 v-if="paymentSection" slot="header" v-on:click="disablePaymentPanel; createSection = !createSection; paymentSection = false; isToggle = true">&ndash;&gt;-->
                                        <!--&lt;!&ndash;<h4 v-if="paymentSection" slot="header">&ndash;&gt;-->
                                        <!--&lt;!&ndash;1. CREATE AN ACCOUNT&ndash;&gt;-->
                                        <!--&lt;!&ndash;<p class="sign-up-info"><b>Email: {{user.email}}</b></p>&ndash;&gt;-->
                                        <!--&lt;!&ndash;</h4>&ndash;&gt;-->
                                        <!--<div class="create-account">-->
                                            <!--&lt;!&ndash;<p class="text-center">Fill out your information below.</p>&ndash;&gt;-->
                                            <!--<br>-->
                                            <!--<div class="form">-->
                                                <!--<form v-on:submit.prevent="onPaymentSubmit">-->

                                                    <!--<div class="col-sm-12">-->
                                                        <!--<h4 v-if="gifteeCol.length > 0">Recipients</h4>-->
                                                        <!--<br />-->
                                                        <!--<div class="table-responsive">-->
                                                            <!--<table v-if="gifteeCol.length > 0">-->
                                                                <!--<thead>-->
                                                                <!--<tr>-->
                                                                    <!--<th>Recipient</th>-->
                                                                    <!--<th>Package</th>-->
                                                                    <!--<th>Message</th>-->
                                                                    <!--<th>Delivery Date</th>-->
                                                                    <!--<th>&nbsp;</th>-->
                                                                <!--</tr>-->
                                                                <!--</thead>-->
                                                                <!--<tbody>-->
                                                                <!--<tr v-for="entry in gifteeCol">-->
                                                                    <!--<td>{{entry.gifteeFirstName}}&nbsp;{{entry.gifteeLastName}}<br>-->
                                                                        <!--{{entry.gifteeEmail}}-->
                                                                    <!--</td>-->
                                                                    <!--<td>{{getPackageInfo(entry.packageId)[0].description}}&nbsp;${{getPackageInfo(entry.packageId)[0].amount}}</td>-->
                                                                    <!--<td>{{entry.deliveryMessage}}</td>-->
                                                                    <!--<td>{{returnFormatedDate(entry.deliveryDate, 'A')}}</td>-->
                                                                    <!--<td><button class="btn formButton" @click="removeGiftee(entry)"><i class="fa fa-times"></i></button></td>-->
                                                                <!--</tr>-->
                                                                <!--</tbody>-->
                                                            <!--</table>-->
                                                        <!--</div>-->
                                                        <!--<div class="right-content" v-if="gifteeCol.length > 0">-->
                                                            <!--<div class="jumbotron text-center">-->
                                                                <!--<p>Total Recipients : <b>{{gifteeCol.length}}</b> </p>-->
                                                                <!--<p>Total Amount: <b>${{this.totalAmount}}</b></p>-->
                                                            <!--</div>-->
                                                        <!--</div>-->
                                                    <!--</div>-->
                                                    <!--<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center padding-minus padding-minus-right">-->
                                                        <!--&lt;!&ndash;<button class="btn formButton btn-block" type="submit" id="signup_button" :disabled="isUserLoggedIn">&ndash;&gt;-->
                                                        <!--<button class="btn formButton btn-block" type="submit" id="signup_button"  :disabled = "!isChecked || this.spinner">-->
                                                            <!--Send Gift-->
                                                            <!--<spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>-->
                                                        <!--</button>-->
                                                    <!--</div>-->
                                                <!--</form>-->
                                            <!--</div>-->
                                        <!--</div>-->
                                    <!--</panel>-->
                                <!--</accordion>-->
                            <!--</div>-->
                        <!--</div>-->

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { input, spinner, accordion, panel, alert, dropdown, radio, checkbox, tabs, tab, buttonGroup, datepicker } from 'vue-strap'
    import VuePassword from 'vue-password'
    import * as authenticate from '../authorizedUsersList'
   // import $ from 'jquery'
    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'accordion': accordion,
            'panel': panel,
            alert,
            dropdown,
            radio,
            VuePassword,
            checkbox,
            tabs,
            tab,
            buttonGroup,
            datepicker
        },
        name: 'signUp',
        data: function () {
            return {
                gifter: {
                    userId: 0,
                    email: '',
                    firstName: '',
                    lastName: '',
                    cardHolderName: '',
                    stripeCustomerId: '',
                    packageId: '',
                    userPayments: [],
                    totalGiftedAmount: 0,
                    userGifts: '',
                    corporationId: 0
                },
                giftee: {
                    gifteeFirstName: '',
                    gifteeLastName: '',
                    gifteeEmail: '',
                    deliveryDate: '',
                    deliveryMessage: '',
                    redeemDate: null,
                    packageId: null
                },
                userPayments: {
                    token: '',
                    stripeCardId: '',
                    paymentType: 'CC',
                    paymentDate: new Date(),
                    paypalPayerId: '',
                    paypalPaymentId: '',
                    paymentMethodNonce: ''
                },
                gifteeValidated: true,
                spinner: false,
                alert: false,
                passwordError: '',
                confirmPassword: '',
                stripe: '',
                card: '',
                panelStatus: false,
                createSection: true,
                paymentSection: false,
                isToggle: false,
                defaultPlan: '',
                isChecked: false,
//                stripeKey: 'pk_test_SLHUyTkZmNS1OnLNdclgNldo',
                stripeKey: 'pk_live_NgwNoBs3GAlrsSez07Zyh4Jc',
                daysToCancel: 0,
                isStripe: true,
                gateway: 'CC',
                packageId: 0,
                gifteeCol: [],
                giftPlans: '',
                totalAmount: 0.00,
                minimumDate: new Date(),
                addMessage: 'Buy Gift',
                dateErrorMessage: 'Delivery date must be ' + this.returnMinimumDate() + ' or later',
                dateFormat: 'mm/dd/yyyy',
                stripeErrorMessage: '',
                csvFile: '',
                clientId: 0
            }
        },
        mounted () {
           // this.mountbraintree()
            if (!authenticate.isUserAuthorized(this.user.email)) {
                this.$router.push('/')
            }
            this.$store.dispatch('GETPLANS').then(() => {
                this.packageId = this.getAllPlans[0].packageId
                this.giftPlans = this.getAllPlans.filter(pln => {
                    return pln.type.toLowerCase() === 'gift'
                })
                if (this.getSelectedGiftId) {
                    this.packageId = this.getSelectedGiftId.giftId
                } else {
                    this.packageId = this.giftPlans[0].packageId
                }
            })
            if (this.user !== null) {
                if (this.user.firstName.length > 0) {
                    this.gifter.firstName = this.user.firstName
                    this.gifter.lastName = this.user.lastName
                    this.gifter.email = this.user.email
                    this.gifter.cardHolderName = `${this.user.firstName} ${this.user.lastName}`
                }
            }
            // Get Corporate Clients
            this.$store.dispatch('GETCORPORATECLIENTS').then(() => {
                if (this.getCorporateClients) {
                    this.clientId = this.getCorporateClients[0].corporationId
                }
            })
        },
        methods: {
            onFileChange (e) {
                var files = e.target.files || e.dataTransfer.files
                if (files.length) {
                    this.readCSVFile(files[0])
                }
            },
            readCSVFile (file) {
                let self = this
                let reader = new FileReader()
                reader.readAsText(file)
                reader.onload = (e) => {
                    let contents = e.target.result
                    self.processCSVFile(contents)
                }
            },
            processCSVFile (csv) {
                var allTextLines = csv.split(/\r\n|\n/)
                var lines = []
                for (var i = 1; i < allTextLines.length; i++) {
                    var data = allTextLines[i].split(',')
                    var tarr = []
                    for (var j = 0; j < data.length; j++) {
                        tarr.push(data[j])
                    }
                    lines.push(tarr)
                }
                console.log(lines)
                if (lines && lines.length > 0) {
                    for (var k = 0; k < lines.length; k++) {
                        let newGiftee = {}
                        newGiftee.packageId = this.packageId
                        newGiftee.gifteeFirstName = lines[k][0]
                        newGiftee.gifteeLastName = lines[k][1]
                        newGiftee.gifteeEmail = lines[k][2].toLowerCase()
                        newGiftee.deliveryMessage = lines[k][3]
                        newGiftee.deliveryDate = this.returnFormatedDate(lines[k][4], 'M')
                        newGiftee.redeemDate = null
                        this.gifteeCol.push(newGiftee)
                    }
                }
            },
            togglePaymentMethods () {
                if (this.gateway === 'paypal') {
                    this.isStripe = false
                    setTimeout(() => {
                        this.mountbraintree()
                    }, 1000)
                } else {
                    this.isStripe = true
                    this.mountStripeElement()
                }
            },
            mountbraintree () {
                let self = this
                if (self.getPaypalToken) {
                    window.braintree.client.create({
                        authorization: 'production_6r7mxqgh_htw3nq9wp32w8h2x'
                    }, function (clientErr, clientInstance) {
                        // Stop if there was a problem creating the client.
                        // This could happen if there is a network error or if the authorization
                        // is invalid.
                        if (clientErr) {
                            console.error('Error creating client:', clientErr)
                            return
                        }
                        // Create a PayPal Checkout component.
                        window.braintree.paypalCheckout.create({
                            client: clientInstance
                        }, function (paypalCheckoutErr, paypalCheckoutInstance) {
                            // Stop if there was a problem creating PayPal Checkout.
                            // This could happen if there was a network error or if it's incorrectly
                            // configured.
                            if (paypalCheckoutErr) {
                                console.error('Error creating PayPal Checkout:', paypalCheckoutErr)
                                return
                            }
                            // Set up PayPal with the checkout.js library
                            window.paypal.Button.render({
                                env: 'production', // or 'sandbox'
                                payment: function () {
                                    return paypalCheckoutInstance.createPayment({
                                        flow: 'vault',
                                        amount: self.totalAmount || 19,
                                        currency: 'USD',
                                        intent: 'sale'
                                        // Your PayPal options here. For available options, see
                                        // http://braintree.github.io/braintree-web/current/PayPalCheckout.html#createPayment
                                    })
                                },
                                onAuthorize: function (data, actions) {
                                    return paypalCheckoutInstance.tokenizePayment(data)
                                        .then(function (payload) {
                                            // console.log('nonce', payload.nonce)
                                            // Submit `payload.nonce` to your server.
                                            self.userPayments.paymentMethodNonce = payload.nonce
                                        })
                                },
                                onCancel: function (data) {
                                    // console.log('checkout.js payment cancelled', JSON.stringify(data, 0, 2))
                                },
                                onError: function (err) {
                                    console.error('checkout.js error', err)
                                }
                            }, '#paypal-button').then(function () {
                                // The PayPal button will be rendered in an html element with the id
                                // `paypal-button`. This function will be called when the PayPal button
                                // is set up and ready to be used.
                            })
                        })
                    })
                }
            },
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            resetForm () {
                setTimeout(() => {
                    this.gifteeValidated = !this.gifteeValidated
                }, 100)
            },
            mountStripeElement () {
                // let stripeKey = this.stripeKey
                setTimeout(() => {
                    this.stripe = window.Stripe(this.stripeKey)
                    const elements = this.stripe.elements()
                    this.card = elements.create('card')
                    this.card.mount('#card-element')
                }, 1000)
            },
            addGiftee () {
                if (this.verifyNameField(this.giftee.gifteeFirstName) && this.verifyNameField(this.giftee.gifteeLastName) && this.verifyEmailField(this.giftee.gifteeEmail)) {
                    let isDateValid = false
                    if (!this.doesEmailExists(this.giftee.gifteeEmail)) {
                        try {
                            let currentDate = new Date(this.returnMinimumDate())
                            currentDate.setHours(0)
                            currentDate.setMinutes(0)
//                            console.log('selected del date', this.giftee.deliveryDate)
//                            let delDate = new Date(this.giftee.deliveryDate + ' 00:00:00')
                            let delDate = new Date(this.giftee.deliveryDate.split('-').join('/'))
                           // delDate.setDate(delDate.getDate() + 1)
                            delDate.setHours(0)
                            delDate.setMinutes(0)
//                            console.log('current date', currentDate)
//                            console.log('del date', delDate)
                            if (delDate >= currentDate) {
//                        if (delDate.getDate() >= currentDate.getDate() && delDate.getMonth() + 1 >= currentDate.getMonth() + 1 && delDate.getFullYear() >= currentDate.getFullYear()) {
                                isDateValid = true
                            } else {
                                isDateValid = false
                                this.$swal({
                                    title: 'Invalid Delivery Date',
                                    text: '',
                                    type: 'error',
                                    timer: 2000,
                                    showCancelButton: false,
                                    showConfirmButton: false
                                }).then(
                                    function () {
                                    },
                                    // handling the promise rejection
                                    function (dismiss) {
                                        if (dismiss === 'timer') {
                                        }
                                    }
                                )
                            }
                        } catch (err) {
                            isDateValid = false
                            this.$swal({
                                title: '',
                                text: 'Invalid delivery date',
                                type: 'failure',
                                timer: 3000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(
                                function () {
                                },
                                // handling the promise rejection
                                function (dismiss) {
                                    if (dismiss === 'timer') {
                                    }
                                }
                            )
                        }
                        if (isDateValid) {
                            let newGiftee = {}
                            newGiftee.packageId = this.packageId
                            newGiftee.gifteeFirstName = this.giftee.gifteeFirstName
                            newGiftee.gifteeLastName = this.giftee.gifteeLastName
                            newGiftee.gifteeEmail = this.giftee.gifteeEmail.toLowerCase()
                            newGiftee.deliveryDate = this.returnFormatedDate(this.giftee.deliveryDate, 'M')
                            newGiftee.deliveryMessage = this.giftee.deliveryMessage
                            newGiftee.redeemDate = null
                            this.gifteeCol.push(newGiftee)
                            this.giftee.packageId = this.packageId
                            this.giftee.gifteeFirstName = ''
                            this.giftee.gifteeLastName = ''
                            this.giftee.gifteeEmail = ''
                            this.giftee.deliveryDate = this.returnMinimumDate()
                            this.giftee.deliveryMessage = ''
                            this.giftee.redeemDate = null
                            this.gifteeValidated = false
//                            console.log('col', this.gifteeCol)
                            this.resetForm()
                        }
                    } else {
                        this.$swal({
                            title: 'Recipient with this email already exists',
                            text: '',
                            type: 'error',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                    }
                }
            },
            removeGiftee (element) {
                const index = this.gifteeCol.indexOf(element)
                this.gifteeCol.splice(index, 1)
            },
            calculateTotalAmount () {
                this.totalAmount = 0
                if (this.gifteeCol && this.gifteeCol.length > 0) {
                    this.addMessage = 'Buy Another Gift'
                    for (var i = 0; i < this.gifteeCol.length; i++) {
                        let packageInfo = this.getPackageInfo(this.gifteeCol[i].packageId)[0]
                        this.totalAmount = parseFloat(this.totalAmount) + parseFloat(packageInfo.amount)
                        this.totalAmount = parseFloat(this.totalAmount).toFixed(2)
                    }
                } else {
                    this.addMessage = 'Buy Gift'
                }
            },
            getPackageInfo (packageId) {
                if (this.getAllPlans) {
                    let pkg = this.getAllPlans.filter(plan => {
                        return plan.packageId === packageId
                    })
                    return pkg
                }
                return null
            },
            verifyPaymentSubmit () {
                if (this.user.packageId > 0) {
                    return false
                }
                return true
            },
            verifyPasswordField (field) {
                if (field.length >= 8) {
                    let re = /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,}).{8,}$/
                    if (!re.test(field)) {
                        this.passwordError = 'Min 8 Chars, One Upper Case, One Lower Case, One Digit!'
                        return false
                    } else {
                        return true
                    }
                } else {
                    if (field.length > 0) {
                        this.passwordError = 'Password must be of 8 charecters at least'
                        return false
                    } else {
                        return true
                    }
                }
            },
            verifyEmailField (field) {
                if (field.length > 0) {
                    let re = /\S+@\S+\.\S+/
                    if (!re.test(field)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
//            verifyFirstName () {
//                if (this.user.firstName.length > 0) {
//                    let re = /^[A-Za-z ]+$/
//                    if (!re.test(this.user.firstName)) {
//                        return false
//                    } else {
//                        return true
//                    }
//                } else {
//                    return false
//                }
//            },
//            verifyLastName () {
//                if (this.user.lastName.length > 0) {
//                    let re = /^[A-Za-z ]+$/
//                    if (!re.test(this.user.lastName)) {
//                        return false
//                    } else {
//                        return true
//                    }
//                } else {
//                    return false
//                }
//            },
//            verifyCardHolderName () {
//                if (this.user.cardHolderName.length > 0) {
//                    let re = /^[A-Za-z ]+$/
//                    if (!re.test(this.user.cardHolderName)) {
//                        return false
//                    } else {
//                        return true
//                    }
//                } else {
//                    return false
//                }
//            },
            verifyNameField (field) {
                if (field.length > 0) {
                    let re = /^[A-Za-z ]+$/
                    if (!re.test(field)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            doesEmailExists (newEmail) {
                if (this.gifteeCol && this.gifteeCol.length > 0) {
                    let exists = this.gifteeCol.filter(giftee => {
                        return giftee.gifteeEmail.toLowerCase() === newEmail.toLowerCase()
                    })
                    if (exists && exists.length > 0) {
                        return true
                    }
                }
                return false
            },
            returnMinimumDate () {
                var today = new Date()
               // today.setDate(today.getDate() + 1)
                var dd = today.getDate()
                var mm = today.getMonth() + 1
                var yyyy = today.getFullYear()
                if (dd < 10) {
                    dd = '0' + dd
                }
                if (mm < 10) {
                    mm = '0' + mm
                }
                today = mm + '/' + dd + '/' + yyyy
                return today
            },
            returnFormatedDate (delDate, format) {
//                let ddate = new Date(delDate + ' 00:00:00')
                let ddate = new Date(delDate.split('-').join('/'))
               // ddate.setDate(ddate.getDate() + 1)
                let dd = ddate.getDate()
                let mm = ddate.getMonth() + 1
                let yyyy = ddate.getFullYear()
                if (dd < 10) {
                    dd = '0' + dd
                }
                if (mm < 10) {
                    mm = '0' + mm
                }
                if (format === 'M') {
                    return `${yyyy}-${mm}-${dd}`
                } else {
                    return `${mm}/${dd}/${yyyy}`
                }
            },
            onPaymentSubmit () {
                this.gifter.email = this.gifter.email.toLowerCase()
                this.gifter.corporationId = this.clientId
                if (this.gifteeCol.length > 0) {
                    this.gifter.userGifts = this.gifteeCol
                    this.spinnerToggle()
                    this.$store.dispatch('ADDCORPORATEGIFTS', {gift: this.gifter}).then(() => {
                        if (!this.error.show) {
                            this.spinnerToggle()
                            this.$router.push('/')
                            this.$swal({
                                title: 'Gifts Sent!',
                                text: '',
                                type: 'success',
                                timer: 4000,
                                showCancelButton: false,
                                showConfirmButton: false
                            }).then(
                                function () {
                                },
                                // handling the promise rejection
                                function (dismiss) {
                                    if (dismiss === 'timer') {
                                    }
                                }
                            )
                        } else {
                            this.spinnerToggle()
                        }
                    })
                } else {
                    this.$swal({
                        title: 'There is no Gift Recipient Added',
                        text: 'Upload csv file',
                        type: 'error',
                        timer: 2000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(
                        function () {
                        },
                        // handling the promise rejection
                        function (dismiss) {
                            if (dismiss === 'timer') {
                            }
                        }
                    )
                }
            }
        },
        computed: {...mapGetters([
            'error', 'isUserLoggedIn', 'getDefaultPlan', 'getAllPlans', 'user', 'getSelectedGiftId', 'getPaypalToken', 'getCorporateClients'])
        },
        watch: {
            'gifter.firstName' (to, from) {
                this.gifter.cardHolderName = `${this.gifter.firstName} ${this.gifter.lastName}`
            },
            'gifter.lastName' (to, from) {
                this.gifter.cardHolderName = `${this.gifter.firstName} ${this.gifter.lastName}`
            },
            'gifteeCol' (to, from) {
                this.calculateTotalAmount()
            },
            'gateway' (to, from) {
                if (this.gateway === 'paypal') {
                    this.card.unmount('#card-element')
                    this.stripeErrorMessage = ''
                    this.isStripe = false
                    this.userPayments.token = ''
                    this.userPayments.paypalPayerId = ''
                    this.userPayments.paypalPaymentId = ''
                    this.userPayments.stripeCardId = ''
                    this.userPayments.paymentType = 'PayPal'
//                    this.user.isPaypalCustomer = '1'
                    this.userPayments.paymentMethodNonce = ''
                    setTimeout(() => {
                        this.mountbraintree()
                    }, 1000)
                } else {
                    this.stripeErrorMessage = ''
                    this.userPayments.token = ''
                    this.userPayments.paypalPayerId = ''
                    this.userPayments.paypalPaymentId = ''
                    this.userPayments.stripeCardId = ''
//                    this.user.isPaypalCustomer = '0'
                    this.userPayments.paymentType = 'CC'
                    this.userPayments.paymentMethodNonce = ''
                    this.isStripe = true
                    setTimeout(() => {
                        this.mountStripeElement()
                    }, 1000)
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .signUp .left-content h4 {
        letter-spacing: 1px;
    }
    .stripeholder {
        position: relative;
    }
    i.fa.fa-lock.overlapstripe {
        position: absolute;
        left: 18px;
        top: 10px;
        font-size: 18px;
        color: #b2b8c7;
    }
    .codediv {
        padding: 10px 0 0;
    }
    .codediv + .row.code {
        padding-top: 0;
    }

    .stripeholder {}

    .codediv .stripeholder {
        margin-bottom: 20px;
    }

    .codediv .col-md-12 {
        min-height: 0;
    }
    .StripeElement {
        background-color: white;
        padding: 2em 1em;
        border: 1px solid #ccc;
        box-shadow: 0 1px 3px 0 #e6ebf1;
        -webkit-transition: box-shadow 150ms ease;
        transition: box-shadow 150ms ease;
        height: 34px;
    }
    .float-right.paymentswitch.btn-group {
        margin: 0 0 30px;
    }
    .StripeElement--focus {
        box-shadow: 0 1px 3px 0 #cfd7df;
    }

    .StripeElement--invalid {
        border-color: #fa755a;
    }

    .StripeElement--webkit-autofill {
        background-color: #fefde5 !important;
    }
    .radiowrapper {
        padding: 0px;
        color: #f0617d;
    }
    /* Media query for mobile viewport*/
    @media screen and (max-width: 400px) {
        #paypal-button-container {
            width: 100%;
        }
    }

    /*Media query for desktop viewport */
    @media screen and (min-width: 400px) {
        #paypal-button-container {
            width: 250px;
            display: inline-block;
        }
    }
    table {
        font-size: 12px;
        letter-spacing: 0;
        width:100%;
    }

    table td {
        text-align: left;
        padding: 12px;
    }

    table th {
        text-align: left;
        padding: 12px;
        background: #f0617d;
        color:#fff;
    }

    h2 {
        color: #f0617d;
        text-transform: capitalize;
        margin: 45px 0 0;
        letter-spacing: 0.5px;
        font-family: sans-serif;
        text-align:center;
    }
    tr {
        border-bottom: 1px solid #ddd;
    }
    li.list-group-item {
        float: left;
        width: 48%;
        padding: 5px;
        margin: 40px 1% 30px;
        background-size: 100px !important;
        border-radius: 0 !important;
        height: auto;
        background-color: #f9f9f9;
        padding-top: 60px;
    }
    li.list-group-item:before {
        background-image: url(../assets/Gift-Ribbon-PNG-Photos.png) !important;
        float: left;
        width: 100%;
        padding: 2%;
        background-size: contain !important;
        border-radius: 0 !important;
        background-color: transparent;
        background-repeat: no-repeat;
        background-position: center top;
        border: 0 none transparent;
        content: "";
        position: absolute;
        top: -43px;
        height: 100px;
    }

    li h5 {letter-spacing: 1px;text-align: center;}
    .row.margin-top {
        margin-bottom: 80px;
    }
    .signUp .right-content .jumbotron {
        padding: 10px;
    }
    .signUp .left-content .panel-body .form-group {
        margin-bottom: 10px;
    }

    /*gift section classes*/
    .gift-item:before {
        background: url(../assets/img_33997.png);
        content:"";
        height: 150px;
        display: block;
    position: absolute;
        background-position: center !important;
        background-repeat: no-repeat !important;
        transform: translateY(-50%);
    top: 0;
        right: 0;
        left: 0;
    }

    .gift-item {
        background: #54d9ec;
        color: #fff;
        margin: 120px 0 0;
        padding: 80px 20px 20px;
        position: relative;
        text-align: center;
    }

    .gift-item h5 {
        font-size: 22px;
    }

    .gift-item h5 small {
        color: #fff;
    }
    .gift-item button {
        background: #0eb4ce;
        border: 2px solid #13a8bf;
        padding: 10px 25px;
        margin: 10px 0;
    }

    .gifts.row {
        margin-bottom: 50px;
    }
    button.active {
        outline: 1px solid blue;
    }
    div#paypal-button {
        /*text-align: left;*/
        margin: 0 12px !important;
        position: relative;
        top: -8px;
    }
    @media(min-width:768px){

        .col-md-8 .col-sm-6 .gift-item {
            padding: 40px 10px 10px;
            margin: 50px 0 10px;
        }

        .col-md-8 .col-sm-6 .gift-item h5 {
            font-size: 16px;
        }

        .col-md-8 .col-sm-6 .gift-item:before {
            height: 80px;
            background-size: contain;
        }

        .col-md-8 .col-sm-6 .gift-item button {
            padding: 5px;
        }

        h4.margin-bot-20 {
            margin: 0 0 70px !important;
        }

        input#corporateUpload {
            margin: 0 0 100px;
        }
    }
    @media(min-width:320px) and (max-width:375px){
        /*table  tr  td:nth-child(2) , table  tr  th:nth-child(2) {*/
            /*display: none;*/
        /*}*/

        /*table  tr  td:nth-child(3) , table  tr  th:nth-child(3) {*/
            /*display: none;*/
        /*}*/
    }

    @media(min-width:376px) and (max-width:425px){

        /*table  tr  td:nth-child(3) , table  tr  th:nth-child(3) {*/
            /*display: none;*/
        /*}*/
    }
    @media(min-width: 320px) and (max-width: 767px){
        table  tr  th{
            white-space: nowrap;
            font-size: 14px;
        }
        table  tr  td{
            white-space: nowrap;
            font-size: 14px;
        }
    }
    .col-md-8 {
        width: 100%;
    }

</style>



// WEBPACK FOOTER //
// CorporateGift.vue?3bac205b